// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as BasicTypes$Showside from "../types/BasicTypes.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as TaggedMediaContent$Showside from "./TaggedMediaContent.bs.js";
import * as RelatedMediaContent$Showside from "./RelatedMediaContent.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function PLPMedia$Slider(Props) {
  var classNameOpt = Props.className;
  var category = Props.category;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var account = match$1.config.transitiveAccount;
  var columns = match.isMobile ? 4.2 : 7.2;
  var defaultLayout = {
    TAG: /* SliderLayout */0,
    _0: {
      slidesPerView: columns,
      gap: BasicTypes$Showside.emptySliderPayload.gap,
      maxWidth: BasicTypes$Showside.emptySliderPayload.maxWidth,
      padding: BasicTypes$Showside.emptySliderPayload.padding,
      rows: BasicTypes$Showside.emptySliderPayload.rows,
      effect: BasicTypes$Showside.emptySliderPayload.effect,
      nav: BasicTypes$Showside.emptySliderPayload.nav,
      transition: BasicTypes$Showside.emptySliderPayload.transition,
      transitionSpeed: BasicTypes$Showside.emptySliderPayload.transitionSpeed,
      autoplay: BasicTypes$Showside.emptySliderPayload.autoplay,
      autoplayDelay: BasicTypes$Showside.emptySliderPayload.autoplayDelay,
      loop: BasicTypes$Showside.emptySliderPayload.loop
    }
  };
  var relatedMediaCount = Belt_Option.flatMap(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), function (connection) {
    return connection.relatedMediaCount;
  });
  var taggedMedia = TaggedMediaContent$Showside.Slider.useSliderTaggedMedia(className, /* Square */1, columns, defaultLayout, category);
  var relatedMedia;
  if (account !== undefined) {
    var match$2 = account.plpRelatedMediaStyle;
    if (match$2 !== undefined && match$2.TAG === /* SliderLayout */0) {
      var connection = Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
      var tmp = {
        at: /* PLP */1,
        scrollableContainerRef: scrollableContainerRef,
        source: connection !== undefined ? {
          TAG: /* ByCategoryId */1,
          _0: connection.categoryId
        } : /* NoSource */0,
        className: className
      };
      if (relatedMediaCount !== undefined) {
        tmp.count = relatedMediaCount;
      }
      relatedMedia = React.createElement(RelatedMediaContent$Showside.Slider.make, tmp);
    } else {
      relatedMedia = null;
    }
  } else {
    relatedMedia = null;
  }
  return Belt_Option.getWithDefault(taggedMedia, relatedMedia);
}
PLPMedia$Slider.displayName = "PLPMedia.Slider";
var Slider = {
  make: PLPMedia$Slider
};
function useInlineMedia(enabledOpt, category) {
  var enabled = enabledOpt !== undefined ? enabledOpt : true;
  var match = ConfigurationProvider$Showside.use(undefined);
  var account = match.config.transitiveAccount;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var taggedMediaEnabled = enabled && Belt_Option.isNone(match$1.productFilters) && Belt_Option.isNone(match$1.productSort);
  var relatedMediaEnabled = taggedMediaEnabled && Belt_Option.mapWithDefault(account, false, function (account) {
    var match = account.plpRelatedMediaStyle;
    if (match !== undefined && match.TAG === /* SliderLayout */0) {
      return false;
    } else {
      return true;
    }
  });
  var relatedMediaCount = Belt_Option.flatMap(Category$Showside.ExternalConnection.getStoreCategoryConnection(category), function (connection) {
    return connection.relatedMediaCount;
  });
  var taggedMedia = Belt_Option.keep(TaggedMediaContent$Showside.Inline.useInlineTaggedMedia(category), function (param) {
    return taggedMediaEnabled;
  });
  var match$2 = Category$Showside.TaggedMedia.getCardSize(category);
  var slotCardOffset = Category$Showside.TaggedMedia.getStartRowOffset(category);
  var connection = Category$Showside.ExternalConnection.getStoreCategoryConnection(category);
  var relatedMedia = RelatedMediaContent$Showside.Inline.useInlineRelatedMedia(relatedMediaCount, /* PLP */1, category, relatedMediaEnabled, connection !== undefined ? {
    TAG: /* ByCategoryId */1,
    _0: connection.categoryId
  } : /* NoSource */0);
  var match$3;
  if (account !== undefined) {
    var match$4 = account.plpRelatedMediaStyle;
    if (match$4 !== undefined && match$4.TAG !== /* SliderLayout */0) {
      var span = match$4._0.span;
      match$3 = [span.width, span.height];
    } else {
      match$3 = [undefined, undefined];
    }
  } else {
    match$3 = [undefined, undefined];
  }
  var relatedMediaSlotCardOffset;
  if (account !== undefined) {
    var match$5 = account.plpRelatedMediaStyle;
    relatedMediaSlotCardOffset = match$5 !== undefined && match$5.TAG !== /* SliderLayout */0 ? match$5._0.startRowOffset : undefined;
  } else {
    relatedMediaSlotCardOffset = undefined;
  }
  var renderSlots = Belt_Option.orElse(taggedMedia, relatedMedia);
  var slotCardWidth = Belt_Option.orElse(match$2[0], match$3[0]);
  var slotCardHeight = Belt_Option.orElse(match$2[1], match$3[1]);
  var slotCardOffset$1 = Belt_Option.orElse(slotCardOffset, relatedMediaSlotCardOffset);
  var slotAllowOverflow = Belt_Option.isSome(taggedMedia);
  return {
    renderSlots: renderSlots,
    slotCardWidth: slotCardWidth,
    slotCardHeight: slotCardHeight,
    slotCardOffset: slotCardOffset$1,
    slotAllowOverflow: slotAllowOverflow
  };
}
var Inline = {
  useInlineMedia: useInlineMedia
};
export { Slider, Inline };
/* react Not a pure module */